import { Injectable } from "@angular/core";
import { EventManagerService } from "event-manager";
import { WincoEvents } from "../enums/winco-events..enum";

/**
 * Servicio asociado al componente Video.
 */
@Injectable({
  providedIn: 'root'
})
export class VideoService
{
  constructor(private eventManagerService: EventManagerService)
  {}

  /**
   * Dispara un evento global para informar de que una reproducción de vídeo debe ser detenida
   */
  stopVideo()
  {
    this.eventManagerService.emitEvent(WincoEvents.STOP_VIDEO);
  }
}
